'use client'

import customAlert from "@/util/customAlert";
import question_icon from "@/public/icon/question_icon.png"
import { useTranslations } from "next-intl";

export default function CopyButton({
    pathName,
    streamDataCode
}: {
    pathName: string,
    streamDataCode: string
}) {
    const a = useTranslations('Sentence')
    const t = useTranslations('Text')
    return (
        <button className={`m-r-8`} onClick={() => {
            async function copyLink(url: string) {
                try {
                    await navigator.clipboard.writeText(url)
                    alert(a('CopiedLink'))
                } catch {
                    prompt(a('CopiedLinkPrompt'), url)
                }
            }
            const url = `${window.location.origin}${pathName}?view_code=${streamDataCode}`;
            const txt = `
                                    <div>
                                        ${a.rich('IOS_Warning', { br: (chunks) => <br /> })}
                                    </div>
                                    <div style='margin-top:10px'>
                                        <a id='externalLink' style='display:inline-block;border:1px solid #ff8c00;padding:0 8px;background:#ff8c00;color:#fff;border-radius:10px;height:40px;line-height:40px;'>${t('링크복사')}</a>
                                    </div>
                                `;

            customAlert(txt, "warning", undefined, {
                htmlMode: true,
                didOpen: () => {
                    document.getElementById("externalLink")?.addEventListener("click", () => {
                        copyLink(url)
                    });
                },
            });
        }}>
            <span>{a('PIPGuide')}</span>
            <span><img src={question_icon.src} alt={""} /></span>
        </button>
    )
}